import FR_FR from './fr-FR.json';
import DE_DE from './de-DE.json';
import ES_ES from './es-ES.json';
import IT_IT from './it-IT.json';
import FR_BE from './fr-BE.json';
import NL_BE from './nl-BE.json';
import FR_LU from './fr-LU.json';
import DE_LU from './de-LU.json';

export const resources = {
  'fr-FR': {
    translation: FR_FR,
  },
  'de-DE': {
    translation: DE_DE,
  },
  'es-ES': {
    translation: ES_ES,
  },
  'it-IT': {
    translation: IT_IT,
  },
  'fr-BE': {
    translation: FR_BE,
  },
  'nl-BE': {
    translation: NL_BE,
  },
  'fr-LU': {
    translation: FR_LU,
  },
  'de-LU': {
    translation: DE_LU,
  },
} as const;